import React, { Component } from 'react'
import './Stores.css'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import Online from '../../images/connection_online.png'
import Offline from '../../images/connection_offline.png'
import AuthenticationService from '../Security/AuthenticationService'
import { Config } from '../../Config'
import { CommonConstants } from '../../Constants'
import moment from 'moment'
import NavigationService from '../Common/NavigationServices'
import 'url-search-params-polyfill'
import { checkAccess } from '../../actions/permissions'
// This component is used for displaying the system status.
class SystemStatus extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showStores: this.props.showStores,
      currentLanguage: languageSettings.getCurrentLanguage(),
      url: null
    }
    this.navigate = new NavigationService()
    this.state.isMasterSettings = window.location.pathname.indexOf('/masterSettings') === -1
    // Binding the methods.
    this.StoreNameCLick = this.StoreNameCLick.bind(this)
    this.checkIsRemoteConnectionPermission = this.checkIsRemoteConnectionPermission.bind(this)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.state.token = this.authService.getToken()
  }
  StoreNameCLick () {
    const params = new URLSearchParams(this.props.history.location.search)
    const uuid = params.get('uuid') ? params.get('uuid') : null
    if (uuid) {
      window.location.href = '/settings/stores/viewdetails?suid=' + this.props.data.systemStatus[0].Store_UID + '&uuid=' + uuid
    } else {
      window.location.href = '/settings/stores/viewdetails?suid=' + this.props.data.systemStatus[0].Store_UID
    }
  }
  renderHTTP (url) {
    return url.replace('https', 'http')
  }
  // Checking the device status.
  renderStatus (isRemoteConnectionPermission, device, deviceName) {
    const language = this.state.currentLanguage
    if (device.Device_IsActive === 1) {
      // If admin - Enable remote actions.
      if (this.authService.isAdmin()) {
        return (<a style={{ 'textAlign': 'center', 'padding-left': '5px', color: parseInt(device.Device_IsActive, 10) === 1 ? 'red' : 'black' }} href={this.navigate.getMenu('connect', device.Device_UID)}>{parseInt(device.Device_IsActive, 10) === 1 ? (deviceName + ' ' + t[language].settingsStoresOnline) : deviceName + ' ' + t[language].settingsStoresOffline}</a>)
      } else if (!this.authService.isAdmin()) { // For public user - checking for the remote permissions.
        if (isRemoteConnectionPermission && device.Device_Name !== 'CIB') {
          return (<a style={{ 'padding-left': '5px', color: parseInt(device.Device_IsActive, 10) === 1 ? 'red' : 'black' }} href={this.navigate.getMenu('connect', device.Device_UID)}>{device.Device_IsActive ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</a>)
        } else {
          return (<span style={{ 'padding-left': '5px', color: 'black' }}>{device.Device_IsActive ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</span>)
        }
      }
    } else {
      return (<span style={{ 'padding-left': '5px', color: 'black' }}>{device.Device_IsActive ? (this.authService.isAdmin() ? deviceName + ' ' + t[language].settingsStoresOnline : t[language].settingsStoresOnline) : ((this.authService.isAdmin() && device.Device_IsActive !== null) ? deviceName + ' ' + t[language].settingsStoresOffline : (device.Device_IsActive !== null ? t[language].settingsStoresOffline : ''))}</span>)
    }
  }
  // Check device status.
  checkIsRemoteConnectionPermission (isRemoteConnectionPermission, displayData, deviceName) {
    return (<td>
      <img src={Online} className={'cstat ' + (parseInt(displayData.Device_IsActive, 10) === 1 ? '' : 'hidden')} alt='Device Online' />
      <img src={Offline} className={'cstat ' + (parseInt(displayData.Device_IsActive, 10) === 0 ? '' : 'hidden')} alt='Device Offline' />
      <span className='cstat systemStatusText'>
        {this.renderStatus(isRemoteConnectionPermission, displayData, deviceName)}
      </span>
    </td>)
  }
  // Main render method.
  render () {
    const language = this.state.currentLanguage
    if (this.props.data !== undefined) {
      // Checking for the remote connect permission.
      let isRemoteConnectionPermission = checkAccess(CommonConstants.userPermissions.RemoteConnect)

      let displayData = this.props.data.systemStatus[0]
      moment.locale('en')
      let deviceName = (displayData.Device_Name !== null && displayData.Device_Name !== undefined) ? displayData.Device_Name : ''
      return (
        <div className='system-settings-status clear'>
          <table className='system-status-table'>
            <tbody>
              <tr>
                <td colspan='2'>
                  <h3 className='clear system_header'>{t[language].settingsStoresSystemStatus}</h3>
                </td>
              </tr>
              <tr className={(this.state.isMasterSettings ? '' : 'hidden')}>
                <th><span>{t[language].settingsStoresSystemName}</span></th>
                <td className='systemStatusText'>{displayData.Device_Name ? displayData.Device_Name : ' ' }</td>
              </tr>
              <tr className={(!this.state.isMasterSettings ? '' : 'hidden')}>
                <th><span>{t[language].settingsStoresSerialNumber}</span></th>
                <td className='systemStatusText'>{displayData.Device_SerialNumber}</td>
              </tr>
              <tr>
                <th><span>{t[language].settingsStoresSystemVersion}</span></th>
                <td className='systemStatusText'>{displayData.Device_MainVersion}</td>
              </tr>
              <tr>
                <th><span>{t[language].settingsDevicesSettingVersion}</span></th>
                <td className='systemStatusText'>{displayData.Device_SettingVersion}</td>
              </tr>

              <tr>
                <th>{t[language].settingsDevicesRegisteredToStoreInfo}</th>
                <td>
                  <ul className='list-style-none registered-store-list'>
                    <li>
                      {
                        !this.state.isMasterSettings && <span>{
                          displayData.Brand_Name ? (displayData.Brand_Name + ' - ' + displayData.Store_Number)
                            : displayData.Store_Number}</span>
                      }
                      {
                        this.state.isMasterSettings && <a className='systemStatus_online_normal systemStatusText' onClick={this.StoreNameCLick}>
                          { displayData.Brand_Name ? (displayData.Brand_Name + ' - ' + displayData.Store_Number)
                            : displayData.Store_Number}
                        </a>
                      }
                    </li>
                    <li className='systemStatusText'>{displayData.Store_AddressLine1}</li>
                    <li className='systemStatusText'>{displayData.Store_Locality}, {displayData.Store_Region}</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th><span>{t[language].settingsDevicesLaneConfiguration}</span></th>
                <td><span className='systemStatusText'>{displayData.LaneConfig_Name !== null ? t[language][displayData.LaneConfig_Name] : '' }</span></td>
              </tr>
              <tr className={(this.state.isMasterSettings ? '' : 'hidden')}>
                <th><span>{t[language].settingsStoresSerialNumber}</span></th>
                <td className='systemStatusText'>{displayData.Device_SerialNumber}</td>
              </tr>
              <tr className={(this.state.isMasterSettings ? '' : 'hidden')}>
                <th><span>{t[language].StoreSettingsHeaderStatus}</span></th>
                {/* Checking for the remote connect permission and displaying the data. */}
                {this.checkIsRemoteConnectionPermission(isRemoteConnectionPermission, displayData, deviceName)}
              </tr>
              <tr className={(this.state.isMasterSettings ? '' : 'hidden')}>
                <th><span>{t[language].settingsDevicesFirstActivity}</span></th>
                <td className='systemStatusText'>{ this.props.data.Device_Created_DTS ? (moment(this.props.data.Device_Created_DTS).locale(language === 1 ? 'fr-ca' : 'en').format('MMMM D, YYYY H:mm ')) : '' }</td>
              </tr>
              <tr className={(this.state.isMasterSettings ? '' : 'hidden')}>
                <th><span>{t[language].settingsDevicesLastActivity}</span></th>
                <td className='systemStatusText'>{ this.props.data.Device_LastMod_DTS ? (moment((this.props.data.Device_LastMod_DTS)).locale(language === 1 ? 'fr-ca' : 'en').format('MMMM D, YYYY H:mm ')) : ''}</td>
              </tr>
              <tr className={(this.state.isMasterSettings ? '' : 'hidden')}>
                <th><span>{t[language].LastUpgrade}</span></th>
                <td className='systemStatusText'>{ this.props.data.Device_LastUpgrade ? (moment(this.props.data.Device_LastUpgrade).locale(language === 1 ? 'fr-ca' : 'en').format('MMMM D, YYYY H:mm ')) : '' }</td>
              </tr>
              <tr className={(this.state.isMasterSettings ? '' : 'hidden')}>
                <th><span>{t[language].settingsDevicesNumberOfRecords}</span></th>
                <td className='systemStatusText'>{this.props.data.totalDevices ? parseInt(this.props.data.totalDevices, 10).toLocaleString() : null}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    } else {
      return (<div />)
    }
  }
}

export default SystemStatus



// WEBPACK FOOTER //
// ./src/components/Stores/SystemStatus.js